import TablePanelDropdown from './TablePanelDropdown.component';

export default TablePanelDropdown;
